import React, { useEffect }  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import './header.scss';
import { Link as LinkRouter } from 'react-router-dom';
import { Link, Avatar } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { datetimeToString } from '../../../../utils/datetime';
import Image from 'material-ui-image';
import { initials } from '../../../../utils/string';
import { useDispatch } from "react-redux";
import { handleGetUniversity } from '../../../../redux/actions/university';
import { handleGetUserInfo } from '../../../../redux/actions/me';
import { handleGetCategories } from '../../../../redux/actions/categories';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    backgroundColor: '#8faecb'
  },
}));


function Header() {  
  const dispatch = useDispatch();
  const classes = useStyles();
  const user = useSelector(state => state.user);
  const picture_thumbnail = useSelector(state => state.me);
  const university = useSelector(state => state.university);
  let firstName = '';
  let lastName = '';
  let university_thumbnail = university && university.data && university.data.logo ? university.data.logo : undefined;

  if(user && user.data && user.data.extraData){
    firstName = user.data.extraData.first_name;
    lastName = user.data.extraData.last_name;
  }

  useEffect(() => {
    dispatch(handleGetUniversity());    
    dispatch(handleGetUserInfo());  
    dispatch(handleGetCategories());
  }, [dispatch]);  

  return (
    <header id="header">
      <div className="wrapper">
        {/* <span className="usr-img"></span> */}
        <Avatar alt="Cindy Baker" 
          src={picture_thumbnail.data}
          className={classes.large}>
          {initials(firstName, lastName)}
        </Avatar>
        <div className="text-info">
          <div className="text-user">
            <div className="hello-text">Hello {user && user.data && user.data.extraData && user.data.extraData.first_name},&nbsp;
              <span className="text-login">
                <Link 
                  component={LinkRouter}
                  to={'/auth/pre-check/'}
                  > 
                  Log out
                </Link>
              </span>
            </div>
            <div className="text-date">{datetimeToString(new Date())}</div>
          </div>
          
          {university && university.data &&           
            <div className="logo">
              {university_thumbnail ? 
                <Image
                  color="#f1f1f1"
                  src={university_thumbnail}
                  disableSpinner={true}
                />
                :
                <div className="university-name">
                  {university.data.name}
                </div>
              }            
            </div>
          }
        </div>        
      </div>      
      
    </header>    
  )
}

export default Header;